module.exports = __webpack_public_path__ + "img/no-img.a4879cd.png";